import { useStaticQuery, graphql } from 'gatsby'

const recentMateriaisQuery = () => {
  const { allWpMaterial } = useStaticQuery(
    graphql`
      query MyRecentMateriais {
        allWpMaterial(limit: 2, skip: 1) {
          nodes {
            id
            title
            excerpt
            date
            slug
            materiaisEducativos {
              data
              link
              tipo
              imagemDestaque {
                sourceUrl
              }
            }
          }
        }
      }
    `
  )
  return allWpMaterial.nodes
}
export default recentMateriaisQuery
